import React, { useReducer } from 'react'
import AuthContext from './authContext'
import AuthReducer from './authReducer'
import { apiCall, setAuthToken } from '../../common/api'
import { response } from '../common'
import {
    USER_LOADED,
    LOGOUT,
    RESPONSE_STATUS,
    COUNT_LOADED,
    COUNT_TEMP_LOADED,
    CLEAR_RESPONSE,
    CALL_END,
} from './authTypes'

const AuthState = (props) => {
    const initialState = {
        token: sessionStorage.getItem('token') || localStorage.getItem('token'),
        isAuthenticated: null,
        isAdmin: null,
        loading: true,
        cartCount: {},
        cartTempCount: {},
        user: null,
        responseStatus: null,
        callEnd: null,
    }

    const [state, dispatch] = useReducer(AuthReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    // Register User
    const register = async (formData, noAlert, fromVariable = 'register') => {
        try {
            // Encrypt data before sending
            const { encryptLoginData } = require('../../common/loginEncryption')
            const encryptedData = await encryptLoginData(formData)

            const [res] = await Promise.all([
                apiCall('post', 'register', encryptedData, '', 'user'),
            ])
            resp.commonResponse(res.data, fromVariable, noAlert)
            if (!formData?.registerToken && global.registerToken) {
                if (global.session) {
                    sessionStorage.setItem('token', res.data.data.responseData.token)
                } else {
                    localStorage.setItem('token', res.data.data.responseData.token)
                }
                loadUser()
            }
        } catch (err) {
            resp.commonErrorResponse('register')
        }
    }

    // Check Email User
    const checkValidation = async (formData, noAlert) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'checkValidation', formData, '', 'user'),
            ])
            resp.commonResponse(res.data, 'checkValidation', noAlert)
        } catch (err) {
            resp.commonErrorResponse('checkValidation')
        }
    }

    // Login User
    const login = async (formData) => {
        try {
            // Encrypt password before sending
            const { encryptLoginData } = require('../../common/loginEncryption')
            const encryptedData = encryptLoginData(formData)

            const [res] = await Promise.all([apiCall('post', 'login', encryptedData, '', 'user')])
            resp.commonResponse(res.data, 'login')
            if (res.data.status === 'success' && res.data.data.token) {
                if (global.session) {
                    sessionStorage.setItem('token', res.data.data.token)
                    sessionStorage.setItem('userId', res.data.data.responseData.id)
                } else {
                    localStorage.setItem('token', res.data.data.token)
                    localStorage.setItem('userId', res.data.data.responseData.id)
                }
                loadUser()
            }
        } catch (err) {
            resp.commonErrorResponse('login')
        }
    }
    // login otp
    const sendPhoneLoginCode = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'sendPhoneLoginCode', formData, '', 'user'),
            ])
            resp.commonResponse(res.data, 'sendPhoneLoginCode')
        } catch (err) {
            resp.commonErrorResponse('sendPhoneLoginCode')
        }
    }
    // Switch User
    const switchUser = async (formData) => {
        try {
            const [res] = await Promise.all([apiCall('post', 'switchuser', formData, '', 'user')])
            resp.commonResponse(res.data, 'switchuser')
            if (res.data.status === 'success') {
                if (global.session) {
                    sessionStorage.setItem('token', res.data.data.token)
                } else {
                    localStorage.setItem('token', res.data.data.token)
                }
                // loadUser()
            }
        } catch (err) {
            resp.commonErrorResponse('switchuser')
        }
    }

    // Load User
    const loadUser = async (data) => {
        if (localStorage.token && !global.session) {
            setAuthToken(localStorage.token)
        } else if (sessionStorage.token) {
            setAuthToken(sessionStorage.token)
        }
        if (data) {
            if (data.token) {
                setAuthToken(data.token)
            }
        }

        const [res] = await Promise.all([apiCall('post', 'validateUser', {}, '', 'user')])
        if (res?.data?.status === 'success') {
            if (
                res.data?.data?.responseData?.status === 'deactivate' ||
                res.data?.data?.responseData?.status === 'deactivated'
            ) {
                await dispatch({
                    type: LOGOUT,
                })
            } else {
                await dispatch({
                    type: USER_LOADED,
                    payload: {
                        data: res.data.data.responseData,
                    },
                })
            }
        } else if (res.data.status === 'error') {
            await dispatch({
                type: LOGOUT,
            })
        } else {
            await dispatch({
                type: LOGOUT,
            })
        }
        await dispatch({
            type: CALL_END,
            payload: res.data,
        })
    }

    // Load Count
    const loadPendingCount = async (formData, data) => {
        const [res] = await Promise.all([apiCall('post', 'pendingCount', formData, '', 'cart')])
        if (res.data.status === 'success') {
            dispatch({
                type: COUNT_LOADED,
                payload: {
                    [data]: res.data.data.responseData,
                },
            })
        }
    }

    const loadPendingTempCount = async (formData, data) => {
        const [res] = await Promise.all([
            apiCall('post', 'pendingCountTemp', formData, '', 'carttemp'),
        ])
        if (res.data.status === 'success') {
            dispatch({
                type: COUNT_TEMP_LOADED,
                payload: {
                    [data]: res.data.data.responseData,
                },
            })
        }
    }

    // Log out
    const logout = async () => {
        try {
            await apiCall('post', 'logout', {}, '', 'user')
        } catch (err) {
            console.log('Logout API error:', err)
        }
        dispatch({
            type: LOGOUT,
        })
    }

    // Clear Response
    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <AuthContext.Provider
            value={{
                token: state.token,
                cartCount: state.cartCount,
                isAuthenticated: state.isAuthenticated,
                isAdmin: state.isAdmin,
                loading: state.loading,
                cartTempCount: state.cartTempCount,
                user: state.user,
                responseStatus: state.responseStatus,
                callEnd: state.callEnd,
                register,
                checkValidation,
                sendPhoneLoginCode,
                login,
                switchUser,
                logout,
                loadUser,
                loadPendingTempCount,
                loadPendingCount,
                clearResponse,
            }}
        >
            {props.children}
        </AuthContext.Provider>
    )
}

export default AuthState
